import type { AccountRow } from '@shared/flow/account-view';
import { FlowTable } from '../FlowTable';
import { useAccountTableModel } from './useAccountTableModel';

/**
 * The bound account mount: presets + column config + the /api/flow/accounts
 * fetch + Rob's cross-dimension toggle chips, composed onto the generic
 * FlowTable. Rows NAVIGATE to the drill-down (no expand, no enroll action).
 *
 * MUST be mounted inside a react-router context (U6): the saved-views state
 * machine reads/writes the shareable `?view=<id>` param through
 * `useSearchParams`.
 *
 * A thin renderer (plan 2026-09-27-007 U2a, D1): all the pre-JSX logic
 * (presets, columns, role-default seeding, the view-state machine, the
 * /api/flow/accounts fetch) lives in `useAccountTableModel` so a future V2
 * mount can call the same hook without forking it.
 */

export interface AccountFlowTableProps {
  /** Row click → drill-down navigation (owned by the mini-app shell). */
  onAccountClick?: (salesforceAccountId: string) => void;
  /** See FlowTableProps.fillHeight — forwarded as-is. */
  fillHeight?: boolean;
}

export function AccountFlowTable({ onAccountClick, fillHeight }: AccountFlowTableProps) {
  const { tableProps } = useAccountTableModel({ onAccountClick });

  return <FlowTable<AccountRow> {...tableProps} fillHeight={fillHeight} />;
}
